export function removeUndefined(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(removeUndefined);
    }
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            acc[key] = removeUndefined(value);
        }
        return acc;
    }, {});
}
//# sourceMappingURL=removeUndefined.js.map